import { type JSX, type ParentProps, Show, splitProps } from "solid-js";
import {
  CollaborationWrapper,
  type UseCollaborationProps,
  useTextCollaboration,
} from "~/components/post-editing/common";
import Tooltip from "../Tooltip";

interface ButtonAsInputProps
  extends ParentProps<UseCollaborationProps<string>> {
  readonly tooltip?: JSX.Element;
  readonly prompt: string;
  readonly onChange?: (value: string) => void;
}

export default function ButtonAsInput(props: ButtonAsInputProps) {
  const [collaborationProps, buttonProps] = splitProps(props, [
    "initialValue",
    "collaborationProvider",
    "collaborationField",
  ]);

  const { outlineColor, value, onChange, onFocus, onBlur, userList } =
    useTextCollaboration(collaborationProps);

  const handleChange: JSX.ChangeEventHandler<HTMLElement, MouseEvent> = (
    event,
  ) => {
    const newValue = prompt(buttonProps.prompt, value());

    if (newValue == null) {
      return;
    }

    onChange(newValue);
    buttonProps.onChange?.(newValue);
  };

  return (
    <CollaborationWrapper
      class={buttonProps.class}
      outline={outlineColor()}
      userList={userList()}
      onFocusIn={onFocus}
      onFocusOut={onBlur}
    >
      <Tooltip
        content={
          <>
            {buttonProps.tooltip}
            <Show when={value()}>
              <br />
              <small>{value()}</small>
            </Show>
          </>
        }
        onClick={handleChange}
      >
        {buttonProps.children}
      </Tooltip>
    </CollaborationWrapper>
  );
}
